export default "__VITE_PUBLIC_ASSET__cde3bf13__"